import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface LoadingState {
  isLoading: boolean;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly loadingSubject = new BehaviorSubject<LoadingState>({ isLoading: false });
  loading$ = this.loadingSubject.asObservable();

  private activeRequests = 0;
  private defaultMessage = 'Please wait...';

  show(message?: string) {
    this.activeRequests++;
    this.loadingSubject.next({
      isLoading: true,
      message: message ?? this.defaultMessage
    });
  }

  hide() {
    this.activeRequests--;
    if (this.activeRequests === 0) {
      this.loadingSubject.next({ isLoading: false });
    }
  }

  reset() {
    this.activeRequests = 0;
    this.loadingSubject.next({ isLoading: false });
  }

  setDefaultMessage(message: string) {
    this.defaultMessage = message;
  }
} 